import { createElement } from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { showsMonitoringTab } from './monitoringTab';

const monitoringTab = EntityContentBlueprint.make({
  name: 'stack-grafana-monitoring',
  params: {
    path: '/monitoring',
    title: 'Monitoring',
    filter: showsMonitoringTab,
    loader: () =>
      import('./components/StackGrafanaContent').then(m =>
        createElement(m.StackGrafanaContent),
      ),
  },
});

export const stackGrafanaPlugin = createFrontendPlugin({
  pluginId: 'stack-grafana',
  extensions: [monitoringTab],
});
